import { riskHelpConfig, riskHelpIds } from "../createRisk/riskHelpData";

export const opportunityHelpIds = {
  IMPACT: 1,
  PROBABILITY: 2,
  VULNERABILITY: 3,
  OPPORTUNITY_LEVEL: 4,
  TREATMENT_ACTION: 5
};

export const opportunityHelpConfig = {
  [opportunityHelpIds.IMPACT]: riskHelpConfig[riskHelpIds.IMPACT],
  [opportunityHelpIds.PROBABILITY]: riskHelpConfig[riskHelpIds.PROBABILITY],
  [opportunityHelpIds.VULNERABILITY]: riskHelpConfig[riskHelpIds.VULNERABILITY],
  [opportunityHelpIds.OPPORTUNITY_LEVEL]: {
    title: "Nivel de Oportunidad",
    columns: [
      { field: "name", header: "Calificación" },
      { field: "valor", header: "Rango (Código)" },
      { field: "posiblesTratamientos", header: "Posibles tratamientos", columnType: "fullText" }
    ],
    data: [
      {
        name: "Oportunidad Bajo",
        valor: "1 a 10 (OB)",
        posiblesTratamientos: "Replantear"
      },
      {
        name: "Oportunidad Medio",
        valor: "11 a 25 (OM)",
        posiblesTratamientos: "Replantear"
      },
      {
        name: "Oportunidad Alto",
        valor: "26 a 50 (OA)",
        posiblesTratamientos:
          "Adopción de nuevas prácticas.\nLanzamiento de nuevos productos educativos o servicios educativos.\nApertura a nuevos mercados.\nConstrucción de asociaciones.\nUtilizando nuevas tecnologías.\nOtras posibilidades deseables y viables"
      },
      {
        name: "Oportunidad Superior",
        valor: "51 a 125 (OS)",
        posiblesTratamientos:
          "Adopción de nuevas prácticas.\nLanzamiento de nuevos productos educativos o servicios educativos.\nApertura a nuevos mercados.\nConstrucción de asociaciones.\nUtilizando nuevas tecnologías.\nOtras posibilidades deseables y viables"
      }
    ]
  },
  [opportunityHelpIds.TREATMENT_ACTION]: {
    title: "Acción de Tratamiento",
    columns: [
      { field: "name", header: "Acción" }
      // Si en el futuro se desea mostrar descripción, descomentar y agregar contenido en data[].description:
      // { field: "description", header: "Descripción", columnType: "fullText" }
    ],
    data: [
      { name: "Replantear" /* description: "" */ },
      { name: "Adopción de nuevas prácticas" /* description: "" */ },
      { name: "Lanzamiento de nuevos productos" /* description: "" */ },
      { name: "Apertura a nuevos mercados" /* description: "" */ },
      { name: "Construcción de asociaciones" /* description: "" */ },
      { name: "Utilizando nuevas tecnologías" /* description: "" */ },
      { name: "Otras posibilidades deseables y viables" /* description: "" */ },
      {
        name: "Lanzamiento de nuevos productos educativos o servicios educativos"
        /* description: "" */
      }
    ]
  }
};
